import { Gender } from '@zorro/clients';
import { Radio } from '@zorro/design-system/v2/Radio';
import { YesNo } from '@zorro/types';
import { Group } from '@zorro/web/design-system';

export const InsuredFormGenderRadios = () => (
  <Group mt="xs" gap="var(--space-40)" wrap="nowrap">
    <Radio value={Gender.MALE} label="Male" />
    <Radio value={Gender.FEMALE} label="Female" />
  </Group>
);

export const InsuredFormYesNoRadios = () => (
  <Group mt="xs" gap="var(--space-40)" wrap="nowrap">
    <Radio value={YesNo.YES} label="Yes" />
    <Radio value={YesNo.NO} label="No" />
  </Group>
);
